import React, { useEffect, useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { usePresentacionContext } from "../context/presentacion.context";
import ComprobantesDialogDetalleTable from "./ComprobantesDialogDetalleTable";
import ComprobantesDialogDetalleTableTasas from "./ComprobantesDialogDetalleTableTasas";
import { consultarTransaccionesDetalles } from "../services/transacciones.service";
import { ProgressSpinnerDemo } from "../../shared/components/progressSpinnerDemo/ProgressSpinnerDemo";
import { isCombustibleAfines } from "../utilities/utils";

const ComprobantesDialogDetalle = () => {
  const {
    presentacion,
    detailsTxSeleccionadas,setDetailsTxDisponibles,setDetailsTxSeleccionadas,selectedProductoComercio,presupuestosList
  } = usePresentacionContext();
  const [cierreLoteString, setCierreLoteString] = useState("");
  const [spinnerTxDetalle, setSpinnerTxDetalle] = useState(false);
  let cierreLote = "";
  useEffect(() => {
    (async () => {
      if (detailsTxSeleccionadas.length > 0) return;
      setSpinnerTxDetalle(true)
      let resultDetailsTransacction = await consultarTransaccionesDetalles(presentacion);
      if (resultDetailsTransacction.status === 200) {
        let tx = resultDetailsTransacction.data.transaccionesSeleccionadas;
        let cierreLoteList = Array.from(
          new Set(
            tx.map(function (item: any) {
              return item.cierreLote;
            })
          )
        );
        let cierreLoteListString = cierreLoteList.join(", ");
        setCierreLoteString(cierreLoteListString);
        setDetailsTxDisponibles(
          resultDetailsTransacction.data.transaccionesDisponibles
        );
        setDetailsTxSeleccionadas(
          resultDetailsTransacction.data.transaccionesSeleccionadas
        );
      }

      setSpinnerTxDetalle(false);
    })();
  }, []);

  if (detailsTxSeleccionadas.length > 0) {
    let tx = detailsTxSeleccionadas;
    let cierreLoteList = Array.from(
      new Set(
        tx.map(function (item: any) {
          return item.cierreLote;
        })
      )
    );
    let cierreLoteListString = cierreLoteList.join(", ");
    //setCierreLoteString(cierreLoteListString)
    cierreLote = cierreLoteListString;
  }

  return (
    <>
      <div className="card">
        <span style={{ textAlign: "center", fontWeight: 600 }}>
          DECLARO QUE LOS SIGUIENTES COMPROBANTES
        </span>
        <ComprobantesDialogDetalleTable />
      </div>
      <div className="card">
        <span style={{ textAlign: "center", fontWeight: 600 }}>
          {isCombustibleAfines(selectedProductoComercio.grupoProductoId) ? 'COINCIDEN CON LOS CIERRES DE LOTES': 'COINCIDEN CON LOS PRESUPUESTOS'}
        </span>
        <div className="p-fluid p-grid">
          <div className="field p-col-12">
            <span className="p-float-label">
              {spinnerTxDetalle ? (
                <div
                  style={{ textAlign: "center", border: "2px solid #0085ca" }}
                >
                  <ProgressSpinnerDemo />
                </div>
              ) : (
                <InputTextarea
                  id="textarea"
                  value={isCombustibleAfines(selectedProductoComercio.grupoProductoId)? (cierreLote ? cierreLote : cierreLoteString) : presupuestosList}
                  rows={3}
                  disabled
                  style={{
                    border: "2px solid #0085ca",
                    marginLeft: "6px",
                    padding: "0.8vw",
                    backgroundColor: "#f4fafe",
                    textAlign: "left",
                  }}
                />
              )}
            </span>
          </div>
        </div>
      </div>
      {isCombustibleAfines(selectedProductoComercio.grupoProductoId) &&
        <div className="card">
          <span style={{ textAlign: "center", fontWeight: 600 }}>
            DECLARO QUE LOS IMPUESTOS ITC, IDC Y TASAS QUE CORRESPONDEN A LA
            PRESENTACIÓN SON LOS SIGUIENTES:
          </span>
          <ComprobantesDialogDetalleTableTasas />
        </div>
      }
    </>
  );
};

export default ComprobantesDialogDetalle;
